import React from 'react';
import { Ear, Type, BookOpen } from 'lucide-react';
export function HowItWorksSection() {
  return <section className="py-20 px-4" data-id="element-63">
      <div className="max-w-5xl mx-auto" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648] mb-4" data-id="element-66">
            Cómo funciona el sistema
          </h2>
          <p className="text-[#4A5568]" data-id="element-67">
            Un proceso natural, lógico y sin estrés.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-68">
          {/* Phase 1 */}
          <div className="bg-white p-8 rounded-2xl border border-[#5C6B60]/10 shadow-sm hover:shadow-md transition-shadow text-center" data-id="element-69">
            <div className="w-16 h-16 bg-[#F5F1EA] rounded-full flex items-center justify-center mx-auto mb-6 text-[#5C6B60]" data-id="element-70">
              <Ear className="w-8 h-8" data-id="element-71" />
            </div>
            <h3 className="text-xl font-bold text-[#2D3648] mb-2" data-id="element-72">Fase 1</h3>
            <p className="text-[#5C6B60] font-medium mb-4" data-id="element-73">
              Reconoce el sonido
            </p>
            <p className="text-sm text-[#4A5568]" data-id="element-74">
              Antes de leer letras, el niño aprende a identificar los sonidos
              del habla. Sin letras, solo oído.
            </p>
          </div>

          {/* Phase 2 */}
          <div className="bg-white p-8 rounded-2xl border border-[#5C6B60]/10 shadow-sm hover:shadow-md transition-shadow text-center relative" data-id="element-75">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#C2644C] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-76">
              CLAVE
            </div>
            <div className="w-16 h-16 bg-[#F5F1EA] rounded-full flex items-center justify-center mx-auto mb-6 text-[#5C6B60]" data-id="element-77">
              <Type className="w-8 h-8" data-id="element-78" />
            </div>
            <h3 className="text-xl font-bold text-[#2D3648] mb-2" data-id="element-79">Fase 2</h3>
            <p className="text-[#5C6B60] font-medium mb-4" data-id="element-80">
              Une sonido y letra
            </p>
            <p className="text-sm text-[#4A5568]" data-id="element-81">
              Conectamos ese sonido familiar con su símbolo gráfico. El "click"
              mental ocurre aquí.
            </p>
          </div>

          {/* Phase 3 */}
          <div className="bg-white p-8 rounded-2xl border border-[#5C6B60]/10 shadow-sm hover:shadow-md transition-shadow text-center" data-id="element-82">
            <div className="w-16 h-16 bg-[#F5F1EA] rounded-full flex items-center justify-center mx-auto mb-6 text-[#5C6B60]" data-id="element-83">
              <BookOpen className="w-8 h-8" data-id="element-84" />
            </div>
            <h3 className="text-xl font-bold text-[#2D3648] mb-2" data-id="element-85">Fase 3</h3>
            <p className="text-[#5C6B60] font-medium mb-4" data-id="element-86">
              Forma su primera palabra
            </p>
            <p className="text-sm text-[#4A5568]" data-id="element-87">
              Juntamos sonidos para crear significado. La lectura nace de la
              comprensión, no de la repetición.
            </p>
          </div>
        </div>

        {/* Real Use Image */}
        <div className="max-w-md mx-auto relative" data-id="element-88">
          <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/5" data-id="element-89">
            <img src="https://cdn.magicpatterns.com/uploads/qbrNZ8mpmtip7tW15vugkm/Green_Brown_Natural_Photo_Collage_Family_Canvas.png" alt="Niños reales usando el sistema de activación lectora" className="w-full h-full object-cover" data-id="element-90" />
          </div>
          <p className="text-center text-sm text-[#8B6F5C] mt-4 italic" data-id="element-91">
            Materiales reales diseñados para manos pequeñas y mentes curiosas.
          </p>
        </div>
      </div>
    </section>;
}